import React, { useEffect, useRef, useState } from "react";
import { Col, Container, NavLink, Row } from "react-bootstrap";
import PlansCard from "../Components/PlansCard";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { Images } from "../Components/Images";
import { getUserPlans } from "../actions/user";
import Header from "../layout/Header";
import NewFooter from "../layout/Footer";
import { CURRENT_CHAIN_ID } from "../Hooks/useWeb3";

const Plans = () => {
  const [plans, setPlans] = useState();

  useEffect(() => {
    getAllUserPlans();
  }, []);

  const getAllUserPlans = async () => {
    try {
      let chainId = CURRENT_CHAIN_ID();
      console.log("🚀 ~ getAllUserPlans ~ chainId:", chainId);
      let { status, message, result } = await getUserPlans({
        chainId: chainId,
      });
      console.log(
        "getAllUserPlans ~ status, message, result:",
        status,
        message,
        result
      );
      setPlans(result);
    } catch (err) {
      console.log(err);
    }
  };

  const swiperRef = useRef(null);
  const goNext = () => {
    if (swiperRef.current && swiperRef.current.swiper)
      swiperRef.current.swiper.slideNext();
  };
  const goPrev = () => {
    if (swiperRef.current && swiperRef.current.swiper)
      swiperRef.current.swiper.slidePrev();
  };

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  // console.log('plans dataaaaaa',plans.length > 0)
  return (
    <>
      <div className="plan_bgVideo">
        {/* <video
          src={Images.bannerBg_vdo}
          autoPlay
          muted
          loop
          className="img-fluid video_src"
        />
        <div className="overlay_bg" />

        <img src={Images.planlftOvly} className="plans__lftBlur img-fluid" />
        <img src={Images.planrytOvly} className="plans__rightBlur img-fluid" /> */}
        <Header />
        <Container fluid className="p-0 custom_container">
          <Container className="home__indexAligner innerpages_ui">
            <div className="plans__holder">
              <h4 className="plans__title text-uppercase hebrew_bold position-relative">
                plans
              </h4>
              <p className="plans__titleHint m-0 hebrew_font position-relative">
                Choose the plan that fits your trading goals. From beginners to high-frequency pros
              </p>
            </div>

            <div className="plans__borderBox mt-4 p-4 rounded-4">
              <h4 className="plans__boxTitle text-uppercase hebrew_bold text-center position-relative mb-3">
                Choose your plan
              </h4>
              {/* <p className="plans__titleHint m-0 hebrew_font text-center position-relative">
                At Sector-8, we envision a future where trading is not just
                about insights
              </p> */}
              <p className="note_txt mt-1 text-center t-grey">
                <span className="fw-bold text-white">Note : </span>The profit is based on
                the liquidity reserves and market oppurtunities
              </p>
              <Row className="mt-5 justify-content-center position-relative">
                {plans?.length > 0 && (
                  <>
                    <button
                      className="plans__swiperPrevBtn rounded-5"
                      onClick={goPrev}
                    >
                      <img src={Images.swiperIcon} />
                    </button>
                    <button
                      className="plans__swiperNextBtn rounded-5"
                      onClick={goNext}
                    >
                      <img src={Images.swiperIcon} />
                    </button>
                  </>
                )}
                <Col xs={12} sm={11}>
                  <Swiper
                    ref={swiperRef}
                    className="mySwiper plans__swiper"
                    navigation={true}
                    modules={[Navigation]}
                    autoplay={{
                      delay: 2500,
                      disableOnInteraction: false,
                    }}
                    // loop={true}
                    breakpoints={{
                      320: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                      },
                      576: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                      },
                      768: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                      },
                      992: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                      },
                      1200: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                      },
                    }}
                  >
                    {plans?.map((item) => (
                      <SwiperSlide>
                        {console.log(item, plans, "item")}
                        <PlansCard data={item} />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </Col>
              </Row>
            </div>

            {/* <NavLink> */}
            {/* <p className="plans__skipper m-0 hebrew_font text-center my-5"> */}
            {/* I will do it later */}
            {/* <i class="fa-solid fa-chevron-right ms-2" /> */}
            {/* </p> */}
            {/* </NavLink> */}
          </Container>
        </Container>
      </div>
      <NewFooter />
    </>
  );
};

export default Plans;
